import React from "react";
import { HOW_IT_WORKS, PRODUCT } from "../config/product";

const HowItWorks = () => {
  return (
    <section
      id="como-funciona"
      data-testid="variants-section"
      className="relative min-h-screen py-32 px-6 md:px-10 flex items-center"
    >
      <div className="max-w-[1400px] mx-auto w-full">
        <div className="max-w-xl mb-16">
          <span className="font-serif-accent text-[#a2e2ff] text-xl">— Cómo funciona</span>
          <h2 className="font-display text-5xl md:text-7xl leading-[0.9] font-bold tracking-tighter mt-3 mb-6">
            Tres pasos
            <br />
            <span className="holo-text">y ya está.</span>
          </h2>
          <p className="font-body text-white/60 text-lg max-w-md leading-relaxed">
            Se coloca entre tu cargador y el cable. No hay que instalar nada ni
            cambiar tu forma de cargar.
          </p>
        </div>

        {/* Pasos */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-12">
          {HOW_IT_WORKS.map((s) => (
            <div
              key={s.step}
              className="group glass rounded-3xl p-8 md:p-10 hover:-translate-y-1 hover:border-white/30 transition-all duration-500"
            >
              <div className="font-display text-6xl font-bold tracking-tighter holo-text mb-6">
                {s.step}
              </div>
              <h3 className="font-display text-xl md:text-2xl font-bold tracking-tight mb-2">
                {s.title}
              </h3>
              <p className="font-body text-white/60 text-sm leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>

        {/* Galería de fotos reales */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {PRODUCT.gallery.map((src, i) => (
            <div
              key={src}
              data-testid={`gallery-img-${i}`}
              className="glass rounded-2xl overflow-hidden aspect-square hover:border-white/30 transition-all duration-500"
            >
              <img
                src={src}
                alt={`${PRODUCT.name} — foto ${i + 1}`}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
